export const HIDE_FOR_NOW = true;

export const CUT_POINT = 1024;
export const NAV_CUT_POINT = 1343;

export function getRandomRange(min, max) {
  return Math.floor(Math.random() * ((max - min) + 1)) + min;
}

// randomize refresh time to a range between 2 and 4 minutes
export const REFRESH_INTERVAL = 1000 * getRandomRange(120, 240);
export const FILTER_THEME = { RTOverlay: '' };

export const STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'DC',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const STATES_WITH_ABBREV = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'DC',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const TIMEZONES = [
  'US/Eastern',
  'US/Central',
  'US/Mountain',
  'US/Pacific',
];

export const VENDORS = ['LHI', 'RF', 'FD', 'IFI', 'AH', 'BJ', 'SAM', 'WAY'];

export const LHI_SOURCES = ['IMS', 'IME', 'Manual', 'Scraper'];

export const NON_LHI_SOURCES = VENDORS.filter(v => v !== 'LHI');

export const ALL_SOURCES = LHI_SOURCES.concat([...NON_LHI_SOURCES, 'PFT', 'SPIG']);

export const DEFAULT_MVW = {
  lhi: false, rf: false, fd: false, ah: false, ifi: false, bj: false, sam: false, way: false,
};

export const VENDOR_NAME_MAP = {
  LHI: 'Lowe\'s',
  RF: 'Refloor',
  FD: 'Floor & Decor',
  IFI: 'Integrity First',
  AH: 'Ace Hardware',
  BJ: 'BJ\'s',
  SAM: 'Sam\'s Club',
  WAY: 'Wayfair',
  PFT: 'Preferred Flooring & Tile',
};

export const VISIBILITY_RANGES = [
  { value: 14, label: '14 Days' },
  { value: 7, label: '7 Days' },
  { value: 3, label: '3 Days' },
  { value: 1, label: 'Today' },
];

export const EMPLOYEE_ROLES = [
  { value: 'office_admin', label: 'Office Administrator' },
  { value: 'regional', label: 'Regional Manager' },
  { value: 'workroom', label: 'Workroom' },
  { value: 'lowes_docs', label: "Lowe's Docs" },
  { value: 'accounting', label: 'Accounting' },
  { value: 'reviews_and_refigures', label: 'Reviews & Refigures' },
  { value: 'admin', label: 'Administrator' },
];

export const CONTRACTOR_ROLES = ['estimator', 'installer'];

export const IC_ISM_POSITIONS = [
  'Installation Coordinator',
  'Installation Service Manager',
  'ISM - LRRP',
  'Production Specialist',
];

export const INSTALLER_UNRESTRICTED_ROLES = [
  'office_admin',
  'accounting',
  'admin',
  'regional',
];

const AC_ERROR = 'AC Error Fix';
const CAPACITY_ISSUE = 'Capacity Issue';
const CUSTOMER = 'Customer';
const CUSTOMER_CALLED = 'Customer - Customer Called';
const CUSTOMER_RESCHEDULE = 'Customer Reschedule';
const DELIVERY_ISSUE = 'Delivery Issue';
const ESTIMATOR_CAPACITY =
  'Estimator Capacity - Unable to Meet Customer Request';
const ESTIMATOR_SWAP = 'Estimator Swap';
const EXISTING_WINDOW = 'Narrowing Time on Existing Window';
const JOBSITE_OBSTRUCTION = 'Jobsite Obstruction';
const JOB_SITE_OBSTRUCTION = 'Job Site Obstruction';
const LOWES_CALLED = "Customer - Lowe's Called";
const NO_SHOW = 'Rescheduling No-Show';
const PRODUCT_DAMAGED = 'Product Damaged';
const PRODUCT_DELAYS = 'Product Delays';
const PRODUCT_DELAY = 'Product Delay';
const PROVIDER_RESCHEDULE = 'Provider Reschedule';
const WITHIN_TARGET = 'Within Target';

export const SCHEDULING_REASONS = [
  { value: CUSTOMER, label: CUSTOMER },
  { value: PRODUCT_DELAYS, label: PRODUCT_DELAYS },
  { value: CAPACITY_ISSUE, label: CAPACITY_ISSUE },
  { value: WITHIN_TARGET, label: WITHIN_TARGET },
];

export const RESCHEDULE_REASONS = [
  { value: PRODUCT_DELAY, label: PRODUCT_DELAY },
  { value: CUSTOMER_RESCHEDULE, label: CUSTOMER },
  { value: PROVIDER_RESCHEDULE, label: PROVIDER_RESCHEDULE },
  { value: JOBSITE_OBSTRUCTION, label: JOB_SITE_OBSTRUCTION },
  { value: PRODUCT_DAMAGED, label: PRODUCT_DAMAGED },
  { value: DELIVERY_ISSUE, label: DELIVERY_ISSUE },
];

export const ASSESSMENT_RESCHEDULE_REASONS = [
  { value: CUSTOMER_CALLED, label: CUSTOMER_CALLED },
  { value: LOWES_CALLED, label: LOWES_CALLED },
  { value: ESTIMATOR_CAPACITY, label: ESTIMATOR_CAPACITY },
  { value: ESTIMATOR_SWAP, label: ESTIMATOR_SWAP },
  { value: EXISTING_WINDOW, label: EXISTING_WINDOW },
  { value: NO_SHOW, label: NO_SHOW },
  { value: AC_ERROR, label: AC_ERROR },
];

export const STORE_CONTACT_POSITIONS = [
  'Customer Service Associate',
  'Sales Specialist of Flooring',
  'Department Manager of Flooring',
  'Store Manager',
  'Department Manager of Installed Sales',
  'Sales Manager',
  'Receiving Clerk',
  'Installed Sales Coordinator',
  'Installed Sales Product Associate',
  'Assistant Store Manager - Sales',
  'Assistant Store Manager - Support',
  'Did Not Specify',
];

export const RESTRICTED_FILTER_POSITIONS = [
  'Assessment Coordinator',
  'Customer Care Specialist',
  'Scheduling Coordinator',
  'Installation Coordinator',
  'Installation Quality Manager',
];

export const PHONE_TYPES = ['mobile', 'desk'];
export const PHONE_TYPES_W_FAX = PHONE_TYPES.concat('fax');

export const INSTALLER_TABS = [
  { label: 'Basic Info', ability: 'installer', editable: true },
  {
    label: 'Millwork Certifications',
    ability: 'installer',
    editable: true,
    fullInstallerUpdateOnly: true,
  },
  { label: 'Pay Rates', ability: 'pay_rate', editable: true },
  { label: 'Crew', ability: 'crew', editable: true },
  { label: 'Traveling Work', ability: 'crew', editable: false },
  { label: 'Time Off', ability: 'pto', editable: false },
  { label: 'Scores', ability: 'installer', editable: false },
  { label: 'User Details History', ability: 'installer', editable: false },
];

const ASSESSMENT = 'Assessment';
const INSTALLATION = 'Installation';
const WORKORDER = 'Workorder';

export const PHASE_TYPES = [ASSESSMENT, INSTALLATION, WORKORDER];

export const APPT_TYPES = [
  { label: ASSESSMENT, value: 'assessment' },
  { label: 'Assessment Hold', value: 'assessment_hold' },
  { label: INSTALLATION, value: 'installation' },
  { label: 'Installation Hold', value: 'installation_hold' },
  { label: 'Stack Cali Bamboo', value: 'stack_cali_bamboo' },
  { label: 'Deliver/Stack Cali Bamboo', value: 'deliver_stack_cali_bamboo' },
  { label: 'Bust Day', value: 'bust_day' },
  { label: 'Jobsite Inspection', value: 'jobsite_inspection' },
  { label: 'Repair', value: 'repair' },
  { label: 'Workorder Inspection', value: 'repair_inspection' },
  { label: 'Crew Inspection', value: 'crew_inspection' },
  { label: 'Delivery', value: 'delivery' },
];

export const REQUIRED_APPT_FIELDS = {
  startDate: 'Start Date',
  endDate: 'End Date',
  arrivalStart: 'Arrival Start',
  arrivalEnd: 'Arrival End',
  schedulingReason: 'Scheduling Reason',
  selectedAssignee: 'Assignee',
};

export const REQUIRED_CV_FIELDS = {
  customerNote: 'Customer Note',
  newConstruction: 'New Construction',
  pavedDriveway: 'Paved Driveway',
  difficultAccess: 'Difficult Access',
  restrictedParking: 'Restricted Parking',
  elevatorAvailable: 'Elevator Available',
  floorBaseHeating: 'Floor/Baseboard Heating',
  freshPaintWalls: 'Freshly Painted Walls',
  petsPresent: 'Pets Present',
  cuttingArea: 'Cutting Area',
  rapidSetMortar: 'Rapid Set Mortar',
  woodSubfloor: 'Wood Subfloor',
  hardyBackerMortar: 'Backer Board + Mortar',
  rolledGoodsTransitions: 'Supplying Transitions For Rolled Goods',
  pickup: 'Pickup',
  gasAppliances: 'Gas Appliances',
  buildingType: 'Building Type',
};

export const REQUIRED_CV_FIELDS_IFI = {
  customerNote: 'Customer Note',
  difficultAccess: 'Difficult Access',
  restrictedParking: 'Restricted Parking',
  elevatorAvailable: 'Elevator Available',
  buildingType: 'Building Type',
  pickup: 'Pickup',
};

export const PHASE_APPOINTMENT_TYPES = {
  Assessment: ['assessment', 'assessment_hold'],
  Installation: [
    'installation',
    'installation_hold',
    'stack_cali_bamboo',
    'deliver_stack_cali_bamboo',
    'jobsite_inspection',
    'bust_day',
    'crew_inspection',
    'delivery',
    'delivery_hold',
  ],
  Workorder: [
    'repair_inspection',
    'repair',
    'stack_cali_bamboo',
    'jobsite_inspection',
    'bust_day',
    'crew_inspection',
    'workorder_hold',
  ],
};

export const ADD_APPT_TYPE_LABELS = {
  assessment: 'Add Appointment',
  assessment_hold: 'Add Assessment Hold',
  installation: 'Add Installation/Hold',
  stack_cali_bamboo: 'Add Stack Cali Bamboo',
  deliver_stack_cali_bamboo: 'Deliver Stack Cali Bamboo',
  jobsite_inspection: 'Add Jobsite Inspection',
  bust_day: 'Add Bust Day',
  crew_inspection: 'Add Crew Inspection',
  delivery: 'Add Delivery',
  repair_inspection: 'Add Virtual Inspection',
  repair: 'Add Repair',
  workorder_hold: 'Workorder Hold',
  delivery_hold: 'Add Delivery Hold',
};

export const DEFAULT_ARRIVAL_WINDOW_HOURS = {
  assessment: 1,
  assessment_hold: 1,
  default: 3,
};

export const WELCOME_CALL_NEEDED_FLAG = 'Welcome Call Needed';

export const VERIFY_BUILD_DATE_FLAG = 'Verify Build Date';

export const ACTIONABLE_KEYS = [
  'appointment confirmation',
  'commercial awaiting approval',
  'complete lrrp task',
  'estimator inquiry',
  'needs appointment',
  'ps assistance',
  'poor score',
  'product confirmation',
  'materials requested',
  'welcome call needed',
  'verify build date',
];

export const CSS_FLAG_KEYS = [
  'presumed lead',
];

export const HOLIDAY_PROMO_FLAG = 'Holiday Promo';

export const PHASE_DETAILS_TABS = [
  {
    label: 'History',
    routeName: 'phase-history',
    path: 'history',
    ability: 'event',
    phaseTypes: PHASE_TYPES,
  },
  {
    label: 'Phase Info',
    routeName: 'phase-info',
    path: 'info',
    ability: 'phase_info',
    phaseTypes: PHASE_TYPES,
  },
  {
    label: 'L/P & Accounting',
    routeName: 'phase-labor-product-accouting',
    path: 'labor-product-accounting',
    ability: ['labor', 'accounting'],
    phaseTypes: PHASE_TYPES,
  },
  {
    label: 'Documents',
    routeName: 'phase-documents',
    path: 'documents',
    ability: 'document',
    phaseTypes: PHASE_TYPES,
  },
  {
    label: 'Contract Verification Checklist',
    routeName: 'phase-cv-checklist',
    path: 'cv-checklist',
    ability: 'labor',
    phaseTypes: [INSTALLATION],
  },
  {
    label: 'Scheduling Checklist',
    routeName: 'phase-scheduling-checklist',
    path: 'scheduling-checklist',
    ability: 'appointment',
    phaseTypes: [INSTALLATION],
  },
  {
    label: 'Appointments',
    routeName: 'phase-appointments',
    path: 'appointments',
    ability: 'appointment',
    phaseTypes: PHASE_TYPES,
  },
  {
    label: 'Related Phases',
    routeName: 'related-phases',
    path: 'related-phases',
    ability: 'related_phase',
    phaseTypes: PHASE_TYPES,
  },
  {
    label: 'Materials',
    routeName: 'warehouse-materials',
    path: 'warehouse-materials',
    ability: 'warehouse',
    phaseTypes: [INSTALLATION, WORKORDER],
  },
  // {
  //   label: 'Survey',
  //   routeName: 'phase-survey',
  //   path: 'phase-survey',
  //   ability: 'survey',
  //   phaseTypes: [INSTALLATION, WORKORDER],
  // },
  {
    label: 'Communication Scripts',
    routeName: 'phase-communications',
    path: 'communications',
    ability: 'communications',
    phaseTypes: [INSTALLATION, WORKORDER],
  },
  {
    label: 'Material Checklist Scripts',
    routeName: 'phase-materials-checklist',
    path: 'materials-checklist',
    ability: 'materials-checklist',
    phaseTypes: [INSTALLATION, WORKORDER],
  },
];

export const MODE_OF_CONTACT = ['Phone', 'Email Address'];

export const AUTO_COMM_METHOD = ['Text', 'Email', 'None'];

export const VINYL_SIZE_CHOICES = [
  'Floating Vinyl Plank',
  '6-ft Wide Sheet',
  '12-ft Wide Sheet',
  '13-ft 2-in Wide Sheet',
  '12-in x 12-in Tile/VCT',
  '18-in x 18-in Tile/VCT',
];

export const JOB_TYPES = ['Replacement', 'New Construction', 'Mobile Home'];

export const CARPET_TYPES = [
  'Plush/Saxony',
  'Berber',
  'Textured',
  'Frieze',
  'Level Loop',
  'Cut and Loop',
];

export const CARPET_SIZES = [
  '12-ft Wide',
  '13-ft 2-in Wide (Wool)',
  '15-ft Wide',
  'Mixed width - 12-ft and 15-ft',
];

export const VINYL_TYPES = [
  'Floating',
  'Full Glue',
  'Vinyl Commercial Tile (VCT)',
];

export const WOOD_FLOORING_TYPES = [
  'Cali Bamboo',
  'Engineered Hardwood',
  'Solid Hardwood',
];

export const WOOD_INSTALL_TYPES = [
  'Glue Down / Edge Glue',
  'Locking / Floating',
  'Nail Down / Staple Down',
];

export const TILE_STONE_LOCATIONS = ['Backsplash Only', 'Decorative Wall'];

export const WALL_JOB_TYPES = ['New Construction', 'Replacement'];

export const TILE_OR_STONE_STYLES = [
  'Ceramic/Porcelain Tile',
  'Stone Tile',
  'Glass Tile',
];

export const TILE_OR_STONE_SIZES = [
  'Mosaic',
  '4-in x 4-in',
  '6-in x 6-in',
  '12-in x 12-in',
  '16-in x 16-in',
];

export const TILE_OR_STONE_PATTERN_TYPES = ['Straight', 'Diagonal'];

export const TILE_JOB_TYPES = ['Replacement', 'New Construction'];

export const TILE_STYLES = [
  'Porcelain/Ceramic Tile',
  'Natural Stone',
  'Saltillo (tile)',
];

export const TILE_SIZES = [
  '6-in x 6-in',
  '12-in x 12-in',
  '18-in x 18-in',
  '24-in x 24-in',
  '6-in x 24-in - Plank',
  '12-in x 24-in - Plank',
  '6-in x 36-in - Plank',
  '8-in x 48-in - Plank',
];

export const TILE_PATTERNS = [
  'Stock Bond (Checker Board)',
  'Diagonal',
  'Custom Inlay',
  'Stacked',
  'Brick',
];

export const DOCUMENT_TYPES = [
  'Contract',
  'PO',
  'Assessment/Refigure',
  'Floor Plan',
  'Photos',
  'Videos',
  'Blank COC',
  'Invoices',
  'Work Order',
  'Purchase Requests',
  'Subcontractor - AP',
  'Receipts',
  'Check Request',
  'Inspection Report',
  'Misc',
  'Signed Documents',
  'Bill of Lading',
  'LRRP Checklists',
];

export const VALID_DOC_FILE_UPLOADS = [
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'gif',
  'csv',
  'ppt',
  'pptx',
  'tiff',
  'tif',
  'mp3',
  'mp4',
  'wav',
  'mov', // Video Codec For Iphones
];

export const REQUIRED_ERROR_MSG = "Can't be blank.";

export const MAX_FILE_SIZE = 1024000000; // 1GB
export const MAX_EXCEL_FILE_SIZE = 3000000; // 3MB
export const FLOOR_WIZARD_TASK_SLUG = 'send_to_floor_wizard';

const CV_RED = '#E59C9C';
const CV_GREEN = '#ACDDB5';
const CV_YELLOW = '#FFF9AF';

export const CONTRACT_VERIFICATION_STATUS_COLORS = {
  'Not Reviewed': '#FFFFFF',
  'Correct, no action': CV_GREEN,
  Resolved: CV_GREEN,
  'Exception - Resolved': CV_GREEN,
  'Error - Labor Short': CV_YELLOW,
  'Error - Labor Incorrect': CV_YELLOW,
  'Error - Product Short': CV_YELLOW,
  'Error - Product Missing': CV_YELLOW,
  'Error - Product Incorrect': CV_YELLOW,
  'Not Enough Information': CV_YELLOW,
  Irrelevant: '#A7D2FF',
  Exception: CV_RED,
  'Requested Product': CV_RED,
  'Installer Pay': CV_GREEN,
};

const CONTRACT_VERIFICATION_STATUSES = [
  'Not Reviewed',
  'Correct, no action',
  'Error - {TYPE} Short',
  'Error - {TYPE} Incorrect',
  'Not Enough Information',
  'Irrelevant',
];

const createCVOptions = (type, ...addl) =>
  CONTRACT_VERIFICATION_STATUSES.map(opt =>
    opt.replace('{TYPE}', type),
  ).concat(addl);

export const LABOR_VERIFICATION_STATUSES = createCVOptions(
  'Labor',
  'Installer Pay',
  'Exception',
  'Exception - Resolved',
);
export const PRODUCT_VERIFICATION_STATUSES = createCVOptions(
  'Product',
  'Error - Product Missing',
  'Exception',
  'Exception - Resolved',
);
export const MERCHANDISE_VERIFICATION_STATUSES = createCVOptions(
  'Product',
  'Requested Product',
  'Resolved',
);

export const WAREHOUSE_MERCHANDISE_STATUSES = [
  'In Warehouse',
  'Released',
  'On Order',
  'Returned to Vendor',
  'Returned to Store',
];

export const WORKORDER_TYPE = [
  'Inspection: Pre-Install',
  'Inspection: Post-Install',
  'Installation Repair',
  'Return - Completion of Multi-Phase Install',
  'Post-Install: Waiting on Product',
  'Reinstall',
];

export const FIRM_NAME = 'Service Pros Installation Group, Inc.';

export const CERTIFICATION_NUMBER = 'NAT-F152318-1';

export const LRRP_DESCRIPTION = 'Flooring installation';

export const WRITTEN_DETERMINATION = 'NO';

export const CERTIFIED_KITS_USED = 'N/A';

export const LEAD_TEST_KIT = 'Hybrivet Systems Leadcheck Lead Test';

export const LEAD_TEST_RESULT = 'Not tested';

export const TEST_INSTALLING_TASK_LIST = ['installing_en_route', 'arrived', 'sign_lrrp', 'departed', 'install_complete'];

// Remove when deployed to all workrooms
export const LRRP_TEST_WORKROOMS = ['Lawrenceville', 'Marietta'];

export const REMOVAL_OPTIONS = [
  { value: 'need_remove_naildown_hardwood', label: 'Remove Naildown Hardwood' },
  { value: 'need_remove_floating_hardwood', label: 'Remove Floating Hardwood' },
  { value: 'need_remove_gluedown_hardwood', label: 'Remove Gluedown Hardwood' },
  { value: 'need_remove_gluedown_carpet', label: 'Remove Gluedown Carpet' },
  { value: 'need_remove_over_pad_carpet', label: 'Remove Carpet Over Pad' },
  { value: 'need_remove_gluedown_vinyl', label: 'Remove Gluedown Vinyl' },
  { value: 'need_remove_vinyl_plank', label: 'Remove Vinyl Plank' },
  { value: 'need_remove_laminate', label: 'Remove Laminate' },
  { value: 'need_remove_tile', label: 'Remove Tile' },
];

export const POTENTIAL_HALT_MESSAGES = {
  powerAnswered:
    'Our installers will be using power tools to complete your installation. I\'d like to get you scheduled as soon as possible, but cannot do so until your home has power. When would be a good time to reach back out to you to schedule?',
  climateControlAnswered:
  'For warranty and installation quality purposes, the home must maintain temperature and humidity levels. I\'d like to get you scheduled as soon as possible, but cannot do so until your home is climate controlled. When would be a good time to reach back out to you to schedule?',
  waterAnswered:
    'You will need to have this turned on prior to the install date as water is required for the mixing of mortar, grout and clean-up of the tile. I\'d like to get you scheduled as soon as possible, but cannot do so until your home has running water. When would be a good time to reach back out to you to schedule?',
};

export const CHECKLIST_RESPONSE_NOTES = {
  okToTextNote:
    '* USER NOTE: Make sure the box next to the number that the customer is ok to receive texts at is filled in (click to check/uncheck) *',
  flagNote:
    '* USER NOTE: If customer is anticipating labor to be done that is not on the contract (such as furniture, oversized furniture, appliances, or a toilet), please add an ISM/IC Callback flag notating customer expectations *',
  workroomNote:
    '* USER NOTE: If customer is anticipating labor to be done that is not on the contract (such as furniture, oversized furniture, appliances, or a toilet), please follow standard process to resolve *',
  priceAdjust:
    'No problem; I will adjust this now. Lowe\'s will reach out regarding an adjustment to the price if applicable',
};

export const CHECKLIST_BASIC_YES_NO_LISTS = {
  showFurnitureNote: {
    intro: { prefix: 'I see that we are moving furniture. ', base: 'Has anyone gone over what we can and cannot move?' },
    can: ['Move all furnishings, but request that they are emptied and that bedding is stripped.'],
    cannot: [
      'Move personal belongings such as jewelry, photos, and clothes.',
      'Move pianos, aquariums, waterbeds, antiques, pool tables, holiday decorations, free standing gas heating units, large exercise equipment, safes.',
      'Remove, replace or reconnect baseboard heaters and wall mounted radiators.',
      'Move any electronics (If it has a power cord it will need to be moved prior to install).',
      'If the customer asks for details (computers, stereos, home theaters, televisions, medical equipment, alarm systems, mechanical beds and living room furniture etc).',
    ],
  },
  showAppliancesNote: {
    intro: { prefix: 'I see that we are moving appliances. ', base: 'Has anyone gone over what we can and cannot move?' },
    can: [],
    cannot: ['Disconnect/reconnect gas appliances or gas heating units.'],
  },
  showToiletNote: {
    intro: { prefix: 'I see that we are removing/replacing a toilet. ', base: 'Has anyone gone over what we can and cannot do with your bathroom furnishings?' },
    can: [],
    cannot: [
      'Remove and reinstall vanities and cabinets.',
      'Reinstall pedestal sinks (we will remove but cannot reinstall).',
      'Install a new toilet (we will remove and replace existing toilet only).',
    ],
  },
};

export const OVERLAP_RESTRICTED_SURFACES = [
  'Hardwood',
  'Tile',
  'Laminate',
  'Vinyl Plank',
  'Backsplash',
];
export const HARD_SURFACES = OVERLAP_RESTRICTED_SURFACES.concat(['Vinyl']);
export const ACTUAL_SURFACE_TYPES = HARD_SURFACES.concat(['Carpet']);
export const SPECIAL_SURFACE_TYPES = ['Pro Direct', 'Multi'];
export const ALL_SURFACE_TYPES = ACTUAL_SURFACE_TYPES.concat(SPECIAL_SURFACE_TYPES);

export const RELATED_SPECIFIC_FIELDS = {
  customer_speaks_english: 'can_speak_english',
  customer_speaks_spanish: 'can_speak_spanish',
  is_backsplash_glass: 'can_do_backsplash_glass',
  is_backsplash_tile: 'can_do_backsplash_tile',
  is_backsplash_blocking: 'can_do_backsplash_blocking',
  is_berber_carpet: 'can_do_berber_carpet',
  is_binding_carpet: 'can_do_binding_carpet',
  is_cali_bamboo_hardwood: 'can_do_cali_bamboo_hardwood',
  is_floating_hardwood: 'can_do_floating_hardwood',
  is_floor_tile: 'can_do_floor_tile',
  is_gluedown_carpet: 'can_do_gluedown_carpet',
  is_gluedown_hardwood: 'can_do_gluedown_hardwood',
  is_large_format_tile: 'can_do_large_format_tile',
  is_naildown_hardwood: 'can_do_naildown_hardwood',
  is_pattern_match_carpet: 'can_do_pattern_match_carpet',
  is_patterns_tile: 'can_do_patterns_tile',
  is_steps_carpet: 'can_do_steps_carpet',
  is_steps_hardwood: 'can_do_steps_hardwood',
  is_stretch_in_carpet: 'can_do_stretch_in_carpet',
  is_vct_lvt: 'can_do_vct_lvt',
  is_vinyl_sheet: 'can_do_vinyl_sheet',
  is_gluedown_vinyl_plank: 'can_do_gluedown_vinyl_plank',
  is_floating_vinyl_plank: 'can_do_floating_vinyl_plank',
  need_move_appliances: 'can_move_appliances',
  need_move_furniture: 'can_move_furniture',
  need_move_furniture_oversized: 'can_move_furniture_oversized',
  need_remove_floating_hardwood: 'can_remove_floating_hardwood',
  need_remove_gluedown_carpet: 'can_remove_gluedown_carpet',
  need_remove_gluedown_hardwood: 'can_remove_gluedown_hardwood',
  need_remove_gluedown_vinyl: 'can_remove_gluedown_vinyl',
  need_remove_laminate: 'can_remove_laminate',
  need_remove_naildown_hardwood: 'can_remove_naildown_hardwood',
  need_remove_over_pad_carpet: 'can_remove_over_pad_carpet',
  need_remove_replace_toilet: 'can_remove_replace_toilet',
  need_remove_tile: 'can_remove_tile',
  need_remove_vinyl_plank: 'can_remove_vinyl_plank',
  need_subfloor_prep: 'can_do_subfloor_prep',
  need_subfloor_replacement: 'can_do_subfloor_replacement',
  need_remove_backsplash: 'can_remove_backsplash',
  need_install_baseboard: 'can_do_baseboard',
  need_hardsurface_transitions: 'can_install_hard_transitions',
};

export const NON_COMPARABLE_SPECIFIC_FIELDS = [
  'id',
  'customer_has_power',
  'customer_has_climate_control',
  'customer_has_water',
  'millwork_specifics',
];

export const ANCHORED_REMOVAL_PLIS = [
  '199745',
  '155161',
  '902961',
  '199589',
  '6573974',
];

export const ANCHORED_REMOVAL_SLUGS = [
  'need_remove_gluedown_hardwood', 'need_remove_naildown_hardwood',
];

export const MULTI_ITEM_AND_SPECIFIC_MAP = {
  Hardwood: {
    matchingSpecifics: [
      'is_steps_hardwood',
      'is_naildown_hardwood',
      'is_gluedown_hardwood',
      'is_floating_hardwood',
      'is_cali_bamboo_hardwood',
    ],
    itemNumbers: [
      'CL035',
      '188204',
      '188208',
      '188400',
      '724006',
      '724007',
    ],
  },
  Carpet: {
    matchingSpecifics: [
      'is_steps_carpet',
      'is_stretch_in_carpet',
      'is_gluedown_carpet',
      'is_pattern_match_carpet',
      'is_binding_carpet',
    ],
    itemNumbers: [
      '167763',
      '503233',
      '227645',
      '228208',
      '700727',
      '729662',
      '282844',
      'CL041'],
  },
  Laminate: {
    matchingSpecifics: [],
    itemNumbers: [],
  },
  Vinyl: {
    matchingSpecifics: ['is_vinyl_sheet'],
    itemNumbers: ['163973'],
  },
  Tile: {
    matchingSpecifics: [
      'is_floor_tile',
      'is_backsplash_tile',
      'is_backsplash_glass',
      'is_large_format_tile',
      'is_patterns_tile',
    ],
    itemNumbers: [
      '104728',
      '104730',
      '104734',
      '227597',
      '475356',
      '475358',
      '475359',
      '808996',
      '143967',
    ],
  },
  Backsplash: {
    matchingSpecifics: [
      'is_backsplash_tile',
      'is_backsplash_glass',
      'is_backsplash_blocking',
    ],
    itemNumbers: [
      '475356',
      '475358',
      '475359',
    ],
  },
  Vinyl_Plank: {
    matchingSpecifics: [
      'is_gluedown_vinyl_plank',
      'is_floating_vinyl_plank',
    ],
    itemNumbers: [
      '503270',
      '1060634',
    ],
    // Floor Leveling: May required further clarification to determine if needed for vinyl_plank.
  },
};

export const SS_PLI_MULTIPLIERS = {
  customer_has_power: {
    itemNumbers: [],
    multiplier: 0,
  },
  customer_has_climate_control: {
    itemNumbers: [],
    multiplier: 0,
  },
  customer_has_water: {
    itemNumbers: [],
    multiplier: 0,
  },
  need_move_furniture: {
    itemNumbers: ['503239', '503252', '503266', '503276', '503273'],
    multiplier: 0.0008,
  },
  need_move_furniture_oversized: {
    itemNumbers: ['CL008'],
    multiplier: 0,
  },
  need_move_appliances: {
    itemNumbers: ['343398', '343405', '343412', '343402', '343409', '475368'],
    multiplier: 0,
  },
  need_subfloor_prep: {
    itemNumbers: ['189009', '204852', '170551', 'CL001', 'CL002'],
    multiplier: 0,
  },
  need_subfloor_replacement: {
    itemNumbers: ['169768', 'CL010'],
    multiplier: 0.008,
  },
  need_remove_replace_toilet: {
    itemNumbers: ['227609', '199993', '227600', '163979', '475369'],
    multiplier: 0,
  },
  is_steps_hardwood: {
    itemNumbers: ['CL035'],
    multiplier: 0.4,
  },
  is_steps_carpet: {
    itemNumbers: ['167763', '503233'],
    multiplier: 0.1,
  },
  need_remove_naildown_hardwood: {
    itemNumbers: ['155161', '199589', '405366', '199745', '902961', '6573974'],
    multiplier: 0.005,
  },
  need_remove_floating_hardwood: {
    itemNumbers: ['153599', '199571', '405367', '199744'],
    multiplier: 0,
  },
  need_remove_gluedown_hardwood: {
    itemNumbers: [
      '170577', '199616', '405365', '902961', '6573974', '199921', '199745',
      '155161', '199589',
    ],
    multiplier: 0.02,
  },
  need_remove_over_pad_carpet: {
    itemNumbers: ['419901', '199406', '405362', '199735'],
    multiplier: 0,
  },
  need_remove_gluedown_carpet: {
    itemNumbers: ['144833', '199475', '405363', '199739'],
    multiplier: 0,
  },
  need_remove_laminate: {
    itemNumbers: ['148631', '199568', '405364', '199743', '894131'],
    multiplier: 0,
  },
  need_remove_tile: {
    itemNumbers: ['174252', '199682', '405361', '199922', '475345'],
    multiplier: 0.04,
  },
  need_remove_gluedown_vinyl: {
    itemNumbers: ['174579', '199704', '199363', '200345', '199381'],
    multiplier: 0,
  },
  need_remove_vinyl_plank: {
    itemNumbers: ['178333', '199723', '199385', '200347'],
    multiplier: 0,
  },
  need_remove_backsplash: {
    itemNumbers: ['475345', '107911'],
    multiplier: 0.08,
  },
  is_naildown_hardwood: {
    itemNumbers: ['188204'],
    multiplier: 0,
  },
  is_gluedown_hardwood: {
    itemNumbers: ['188208'],
    multiplier: 0,
  },
  is_floating_hardwood: {
    itemNumbers: ['188400', '724006', '724007'],
    multiplier: 0,
  },
  is_cali_bamboo_hardwood: {
    itemNumbers: ['712505', '712217', '712504'],
    multiplier: 0,
  },
  is_vinyl_sheet: {
    itemNumbers: ['163973'],
    multiplier: 0,
  },
  is_vct_lvt: {
    itemNumbers: ['163978'],
    multiplier: 0,
  },
  is_stretch_in_carpet: {
    itemNumbers: ['227645', '228208', '700727', '729662'],
    multiplier: 0,
  },
  is_gluedown_carpet: {
    itemNumbers: ['282844'],
    multiplier: 0,
  },
  is_binding_carpet: {
    itemNumbers: ['CL041'],
    multiplier: 0,
  },
  is_pattern_match_carpet: {
    itemNumbers: [],
    multiplier: 0,
  },
  is_berber_carpet: {
    itemNumbers: [],
    multiplier: 0,
  },
  is_floor_tile: {
    itemNumbers: ['104728', '104730', '104734', '227597'],
    multiplier: 0,
  },
  is_backsplash_tile: {
    itemNumbers: ['475356', '475358'],
    multiplier: 0,
  },
  is_backsplash_glass: {
    itemNumbers: ['475359'],
    multiplier: 0,
  },
  is_patterns_tile: {
    itemNumbers: ['143967'],
    multiplier: 0,
  },
  is_large_format_tile: {
    itemNumbers: ['808996'],
    multiplier: 0,
  },
};

export const MULTI_SURFACE_ENABLED = ['Carpet'];
export const TIME_CONSTRAINT_MESSAGES = [
  'day marked unavailable',
  'multi-day appt conflict',
  '2 appts already scheduled for this day',
  'times overlap',
  'one-appt-a-day limit for hard surfaces',
];
export const TWD_MESSAGES = [
  'Phase zip code not covered by this crew',
  'Crew traveling outside assigned territory',
];

export const WORK_DAY_HOURS = 9;

export const DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
export const SCHEDULE_DATE = 'M/D/YYYY';
export const DISPLAY_DATE = 'MM/DD/YYYY';
export const DISPLAY_TIME = 'h:mm a';
export const DISPLAY_DATE_TIME = `${DISPLAY_DATE} ${DISPLAY_TIME}`;
export const OTHER_DATE = 'MM-DD-YYYY';
export const RAILS_DATE = 'YYYY-MM-DD';
export const RAILS_DATE_ALT = 'YYYY-M-D';
export const RAILS_TIME = 'HH:mm:ss';
export const RAILS_DATE_TIME = 'YYYY-MM-DD HH:mm:ss';
export const MOMENT_TIME = 'HH:mm';

export const AUTO_COMM_MESSAGE =
  'Changing start date/time will automatically notify the customer';

export const ASSIGNEE_OPTIONS = [
  { label: 'IQM', value: 'IQM' },
  { label: 'Crew', value: 'Crew' },
  { label: 'Estimator', value: 'Estimator' },
  { label: 'Employee', value: 'Employee' },
];

export const ALLOWED_DASHBOARD_POSITIONS = [
  'Installation Service Manager',
  'ISM - LRRP',
  'Installation Coordinator',
  'District Operations Manager',
  'Regional Operations Manager',
  'Director',
  'Developer',
  'Data Analyst',
];

export const ALLOWED_DASHBOARD_NAMES = [];

export const TOTAL_DAY_LIMIT = 30;

export const ASSESSMENT_LABOR_ITEMS = ['CL055', 'CL056', 'CL057', 'CL058'];

export const SPIG_ADDTL_MILEAGE_ITEMS = ['154381', '154569', '154592', '227804', '476923'];

export const IFI_ADDTL_MILEAGE_ITEMS = [
  '8875749',
  '8875751',
  '154641',
  '154658',
  '154660',
  '903182',
];

export const ADDTL_MILEAGE_ITEMS = SPIG_ADDTL_MILEAGE_ITEMS.concat(IFI_ADDTL_MILEAGE_ITEMS);

export const IFI_ASSESSMENT_DETAIL_ITEMS = [
  '111511',
  '111537',
  '111551',
  '176957',
  '903180',
  '1058953',
  '1058959',
  '8836814',
  '8875748',
  '8875750',
  '8931897',
  '8931896',
];


export const SPIG_ASSESSMENT_DETAIL_ITEMS = [
  '111630',
  '111676',
  '111719',
  '111731',
  '176387',
  '172447',
  '1026526',
];

export const ASSESSMENT_DETAIL_ITEMS =
  SPIG_ASSESSMENT_DETAIL_ITEMS.concat(IFI_ASSESSMENT_DETAIL_ITEMS);

export const FIXED_LINE_ITEMS = [
  { label: 'CL055 - No Show - Estimation', price: 10, total: 10 },
  { label: 'CL056 - Trip Charge - Estimation', price: 1 },
];

export const DELIVERY_SURFACE_TYPES_BLACKLIST = ['Carpet'];

export const NUM_DAYS_MOBILE = 1;
export const NUM_DAYS_DESKTOP = 7;

export const SCRIPT_STATUSES = ['ready_to_review', 'installing', 'in_progress', 'follow_up',
  'delivery'];

export const DELIVERY_BUFFERS = {
  1: [3, 7],
  2: [null],
  3: [1],
  4: [3],
  5: [1],
  6: [1],
  7: [1],
};

export const BASE_DELIVERY_LIMIT = 4;

export const EMAIL_VALIDATION_REGEX = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

export const MILLWORK_SURFACES = [10, 11, 12, 13];



// WEBPACK FOOTER //
// ./client/app/shared/config/constants.js